"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireDefault(require("react"));
var _styledComponents = require("styled-components");
var _inline_svg = require("./inline_svg.utils");
var _inline_svg2 = _interopRequireDefault(require("./inline_svg.proptypes"));
var _excluded = ["fontsize", "themeColor"];
var DirectionRun = function DirectionRun(props) {
  var fontsize = props.fontsize,
    themeColor = props.themeColor,
    rest = (0, _objectWithoutProperties2.default)(props, _excluded);
  var theme = _react.default.useContext(_styledComponents.ThemeContext);
  var _parseStyles = (0, _inline_svg.parseStyles)({
      fontsize: fontsize,
      themeColor: themeColor
    }, theme),
    sizeStyles = _parseStyles.sizeStyles,
    colorStyles = _parseStyles.colorStyles;
  return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({}, sizeStyles, {
    viewBox: "0 0 14 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, rest), /*#__PURE__*/_react.default.createElement("path", (0, _extends2.default)({
    fillRule: "evenodd",
    clipRule: "evenodd" // eslint-disable-next-line max-len
    ,

    d: "M10.9083 1.90007C10.9083 2.81673 10.1583 3.56673 9.24166 3.56673C8.32499 3.56673 7.57499 2.81673 7.57499 1.90007C7.57499 0.983398 8.32499 0.233398 9.24166 0.233398C10.1583 0.233398 10.9083 0.983398 10.9083 1.90007ZM7.07499 11.4834L6.24166 15.1501L0.408325 13.9834L0.741659 12.3167L4.82499 13.1501L6.15833 6.40007L4.65833 6.9834V9.81673H2.99166V5.90007L7.32499 4.06673C7.44999 4.06673 7.55416 4.0459 7.65833 4.02507C7.76249 4.00423 7.86666 3.9834 7.99166 3.9834C8.57499 3.9834 9.07499 4.31673 9.40833 4.81673L10.2417 6.15007C10.9083 7.31673 12.2417 8.15007 13.825 8.15007V9.81673C11.9917 9.81673 10.325 8.9834 9.24166 7.7334L8.74166 10.2334L10.4917 11.9001V18.1501H8.82499V13.1501L7.07499 11.4834Z",
    fill: "#75767A"
  }, colorStyles)));
};
DirectionRun.propTypes = _inline_svg2.default.propTypes;
DirectionRun.defaultProps = _inline_svg2.default.defaultProps;
var _default = DirectionRun;
exports.default = _default;